import React, { useEffect } from "react";
import { Col, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";

import modalLogo from "../../assets/images/modalLogo1.png";
import welcomemodalperson from "../../assets/images/welcomemodalperson.gif";
import { useLocation, useNavigate } from "react-router-dom";


import { useDispatch } from "react-redux";
import usePersistStoreData from "../Hooks/usePersistStoreData";
import { logoutThunk, logoutUser } from "../../slices/thunks";
import { showToast } from "../ToastNotification";
import { useSelector } from "react-redux";
import { store } from "../../store";


const WelcomeModal = ({ showModal, onCloseClick , setShowModal}) => {
  const navigate = useNavigate();
 
  const location = useLocation();
    const dispatch = useDispatch();
    const { userData } = usePersistStoreData();
    const token = userData?.token;
    
    const { logoutLoading } = useSelector(
        (state) => state.Logout_user
      );
    const handleLogout = () => {
        dispatch(logoutThunk({ token }))
          .unwrap()
          .then(() => {
            showToast("Logged Out Successfully", "success");
            navigate("/login");
            store.dispatch(logoutUser());

          })
          .catch((error) => {
            showToast(
                error?.message || "Something went wrong, please try again",
                "error"
              );
          });
      };
    
      useEffect(() => {
        const welcomeModalStatus = sessionStorage.getItem("welcomeModalShown");
        // Open modal only if the flag is "true"
        if (welcomeModalStatus === "true") {
          setShowModal(true);
        } else {
          onCloseClick();
        }
      }, []);
  return (
    <Modal isOpen={showModal} toggle={onCloseClick} centered={true}
    contentClassName="welcome-modal-content"
    style={{
      border:"0 !important"
    }}
    size="lg"
    >
      {/* <ModalHeader toggle={onCloseClick}>Logout</ModalHeader> */}
      <ModalBody className="" style={{
        borderRadius: "10px",
      }}>
        <Row className="align-items-center">
          {/* Left Column - Image */}
          <Col xs="12" md="5" className="text-center">
            
            <img src={welcomemodalperson} alt="welcome" 
              style={{
                width: "100%",
                // height: "250px",
              }}
            />
          </Col>
          
          {/* Right Column - Content */}
          <Col xs="12" md="7">
            <div className="text-center">
              <img
                className=""
                src={modalLogo} 
                style={{
                  filter: 'brightness(0) invert(1)',
                  width: "60%",
                }} 
                alt="logo"
              />
              <h2 className="fs-24 fw-semibold mb-0 mt-3" style={{color:"#FFFFFF"}}>
                Hi {userData?.name}, 
              </h2>
              <h2 className="fs-24 fw-semibold mb-1 " style={{color:"#FFFFFF"}}>
                 Welcome to B.N.Rathi
              </h2>
              <span className="fs-18 fw-regular text-center"
                style={{
                  color:"#FFFFFF"
                }}
              >
                Take first step by completing your profile details 
              </span>
            </div>

            <Row className="mt-4">
              <Col xs="12" lg="6" className="mb-2 d-lg-block"

              >
                <button
                  type="button"
                  className="btn border w-100 centerContent"
                  data-bs-dismiss="modal"
                  style={{ backgroundColor: "#FFFFFF" }}
                  onClick={onCloseClick}
                >
                  Cancel
                </button>
              </Col>
              <Col xs="12" lg="6" className="mb-2 mb-md-0">
                <button
                  type="button"
                  className="btn btn-success border w-100"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    navigate("/profile");
                    onCloseClick();
                  }}
                >
                  Complete my Profile
                </button>
              </Col>
            </Row>
          </Col>
        </Row>
        
        {/* Commented section preserved as in original code */}
        {/* <div className="centerContent">
        <span
        className="fs-14 fw-medium bg-success text-white p-1 me-2 mt-2"
        style={{
          borderRadius: "4px",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "1.2rem",
          height: "1.2rem",
        }}
      >
        <i className="fa fa-check" aria-hidden="true"></i>
      </span>
        <span className="fs-14 fw-medium mt-2 centerContent" style={{
          color:"#FFFFFF"
        }}>30% of your profile setup is already completed </span>
        </div> */}
      </ModalBody>
    </Modal>
  );
};

export default WelcomeModal;
